import React from 'react';
export var Circle = function Circle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "6.5",
    cy: "6.5",
    r: "5.5",
    fill: props.fill ? 'inherit' : 'none',
    stroke: props.fill ? 'none' : 'inherit',
    strokeWidth: "1"
  }));
};
export var Bullet = function Bullet(props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "3",
    r: "2.5",
    fill: props.fill ? 'inherit' : 'none',
    stroke: props.fill ? 'none' : 'inherit',
    strokeWidth: "1"
  }));
};